import React from 'react';

import ProgressCircle from './ProgressCircle';
import { useExchange } from 'context/exchange/ExchangeContext';

export function BridgeProgress() {
  const { bridgeStatus } = useExchange();
  if (!bridgeStatus) return null;

  const ethBlockStatus = `(${bridgeStatus.progressUnits} / ${bridgeStatus.totalUnits} - 96 ETH blocks)…`;
  //const isEthDone = bridgeProgress.progressBlocks.gte(bridgeProgress.totalBlocks);
  //const ethDoneStatus = '(Waiting for Onomy Validation)…';

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <ProgressCircle
      message={`Bridging assets ${/*isEthDone ? ethDoneStatus :*/ ethBlockStatus}`}
      percent={100 * (bridgeStatus.progressUnits / bridgeStatus.totalUnits)}
    />
  );
}
